import React from "react";
import styled from "styled-components";

const BoardMemberCard = () => {
  return (
    <StyledBoardMemberCard>
      <Container>
        <h1>Akshay Kothe</h1>
        <h5>Founder, Chairman and Managing Director</h5>
        <Content>
          <LeftSide>
            <ProfileImage
              src="https://www.nextechplm.com/web-assets/assets/images/team/akshay_sir.png"
              alt="Akshay Kothe"
            />
            <IconSocial>
              <a
                href="https://www.linkedin.com/in/teamcenter-faithplm/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-linkedin bg-linkedin"></i>
              </a>
              {/* Replace with Twitter link */}
              <a href="#" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-x-twitter bg-twitter"></i>
              </a>
            </IconSocial>
          </LeftSide>
          <RightSide>
            <p>
              Akshay is a seasoned professional with over 14 years of extensive
              experience in the Teamcenter application landscape. His expertise
              spans across various facets including Teamcenter Deployment,
              Customization, Upgrade, Data Migration, and Integrations (T4O,
              T4S, T4EA).
            </p>
            <p>
              During his illustrious career, Akshay has spent more than 8 years
              with Siemens, contributing significantly to product development.
              His work in Siemens focused on critical areas such as BOM (Bill of
              Materials) management, product configurator, and Active Workspace.
              These roles enabled him to hone his skills in managing complex
              product data and developing user-friendly interfaces that
              streamline workflow.
            </p>
            <p>
              Akshay also served as a Teamcenter Solution Architect at Tata
              Consultancy Services (TCS) for 7 years. In this capacity, he led
              numerous projects, offering innovative solutions and ensuring
              seamless implementation of Teamcenter systems. His role at TCS
              further cemented his reputation as a strategic thinker and a
              problem solver.
            </p>
            <p>
              Currently, Akshay is responsible for solution development and
              delivery at NexTech PLM. In addition to his technical
              responsibilities, he is also focused on competency building,
              ensuring that his team stays abreast of the latest technologies
              and industry trends. His leadership and commitment to excellence
              continue to drive the success of the projects he undertakes.
            </p>
          </RightSide>
        </Content>
      </Container>
    </StyledBoardMemberCard>
  );
};

export default BoardMemberCard;

// Styled Components
const StyledBoardMemberCard = styled.section`
  padding: 1rem 2rem;
  border-radius: 10px;
  max-width: 900px;
  margin: 2rem auto;
`;

const Container = styled.div`
  h1 {
    font-size: 3.1rem;
    font-family: "Space Grotesk", sans-serif;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #07b6f2;
  }

  h5 {
    font-size: 1.3rem;
    font-family: "Jost", sans-serif;
    font-weight: normal;
    margin-bottom: 1.5rem;
    color: #777;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }

    h5 {
      font-size: 1.1rem;
    }
  }
  
  @media (max-width: 480px) {
    h1 {
      font-size: 2em;
      text-align: center;
    }
    h5 {
      font-size: 1em;
      text-align: center;
    }
  }

`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 2rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const IconSocial = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  a {
    margin: 0 0.5rem;
    font-size: 1.5rem;
    color: #000;
    transition: color 0.3s;

    &:hover {
      color: #0077b5; /* LinkedIn color */
    }
  }

  .bg-linkedin {
    color: #0077b5;
  }
  .bg-twitter {
    color: #555;
  }
`;

const RightSide = styled.div`
  flex: 1;

  p {
    font-size: 1.2rem;
    font-family: "Jost", sans-serif;
    color: #777777;
    line-height: 2;
    text-align: justify;
  }

  @media (max-width: 768px) {
    p {
      text-align: justify;
    }
  }

  @media (max-width: 480px) {
    p {
      font-size: 1em;
    }
  }
`;
